/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled               from 'styled-components';
import { Colours, Spacing } from '../../../styles/variables';
import { Media }            from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledTableListItem = styled.li`
  padding: ${Spacing.Tiny} 0;
  &:not(:first-child) {
    border-top: 1px solid ${Colours.Alto};
  }
  ${Media.Tablet`
    display: flex;
  `} 
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledTableListItem/index.js